import { cB, cM } from '../../../_utils/cssr'

export default cB('space', [
  cM('rtl', `
    direction: rtl;
  `)
])
